export var AvailableLanguages;
(function (AvailableLanguages) {
    AvailableLanguages["English"] = "en";
    AvailableLanguages["Russian"] = "ru";
})(AvailableLanguages || (AvailableLanguages = {}));
